<div>
    <div class="contentTopNew mb-10">
        <div class="title">
            <a [routerLink]="['/dashboard']" class="backbutton">
                <fa-icon [icon]="backbtn" style="color: #009dd9"></fa-icon>
            </a>
            &nbsp;Raise New ACD
        </div>

    <div id="containerform" class="chv-wizard-container">
        <div class="chv-wizard-step active">
            <div id="Icon1" class="chv-wizard-icon">1</div>
            <div id="Label1" class="chv-wizard-label">Define Request</div>
            <div class="chv-wizard-sep"></div>
        </div>
        <div class="chv-wizard-step next">
            <div id="Icon2" class="chv-wizard-icon">2</div>
            <div id="Label2" class="chv-wizard-label">Search</div>
            <div class="chv-wizard-sep"></div>
        </div>
        <div class="chv-wizard-step next">
            <div id="Icon3" class="chv-wizard-icon">3</div>
            <div id="Label3" class="chv-wizard-label">Build</div>
            <div class="chv-wizard-sep"></div>
        </div>
        <div class="chv-wizard-step next">
            <div id="Icon4" class="chv-wizard-icon">4</div>
            <div id="Label4" class="chv-wizard-label">ACD Summary</div>
        </div>
    </div>
</div>

    <app-acd-form></app-acd-form>
</div>